import { create } from "zustand";
import { toast } from "react-toastify";
import axiosToken from "../api/axiosClient";

const useGiftCardStore = create((set, get) => ({
  // State
  giftCards: [],
  currentGiftCard: null,
  isLoading: false,
  isCreating: false,
  isUsing: false,

  // Actions
  // Récupérer toutes les cartes cadeau
  getAllGiftCards: async () => {
    set({ isLoading: true });
    try {
      const response = await axiosToken.get(`/gift-card`);
      const cardData = response.data.data.cards;
      // console.log({cardData})
      set({ giftCards: cardData, isLoading: false });
      return cardData;
    } catch (error) {
      console.error("Erreur lors de la récupération des cartes cadeau:", error);
      toast.error("Erreur lors du chargement des cartes cadeau");
      set({ isLoading: false });
      throw error;
    }
  },

  // Récupérer une carte par ID
  getGiftCardById: async (id) => {
    set({ isLoading: true });
    try {
      const response = await axiosToken.get(`/gift-card/${id}`);
      const cardId = response.data.data;
      set({ currentGiftCard: cardId, isLoading: false });
      return cardId;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de la carte cadeau:",
        error,
      );
      toast.error("Erreur lors du chargement de la carte cadeau");
      set({ isLoading: false });
      throw error;
    }
  },

  // Récupérer une carte par code
  getGiftCardByCode: async (code) => {
    set({ isLoading: true });
    try {
      const response = await axiosToken.get(`/gift-card/code/${code}`);
      set({ currentGiftCard: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de la carte cadeau:",
        error,
      );
      toast.error("Carte cadeau non trouvée");
      set({ isLoading: false });
      throw error;
    }
  },

  // Créer une carte cadeau
  createGiftCard: async (services) => {
    set({ isCreating: true });
    try {
      const response = await axiosToken.post(
        `/gift-card/create/standalone`,
        services,
      );
      toast.success("Carte cadeau créée avec succès");
      set({ isCreating: false });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de la carte cadeau:", error);
      toast.error("Erreur lors de la création de la carte cadeau");
      set({ isCreating: false });
      throw error;
    }
  },

  // Marquer une carte comme utilisée
  setAsUsedGiftCard: async (id) => {
    set({ isUsing: true });
    try {
      const response = await axiosToken.patch(`/gift-card/${id}/use`);
      toast.success("Carte cadeau marquée comme utilisée");

      // Mettre à jour la carte dans la liste
      const { giftCards, currentGiftCard } = get();
      const updatedGiftCards = giftCards.map((card) =>
        card.id === id
          ? { ...card, isUsed: true, usedAt: new Date().toISOString() }
          : card,
      );

      if (currentGiftCard && currentGiftCard.id === id) {
        set({
          currentGiftCard: {
            ...currentGiftCard,
            isUsed: true,
            usedAt: new Date().toISOString(),
          },
          giftCards: updatedGiftCards,
          isUsing: false,
        });
      } else {
        set({ giftCards: updatedGiftCards, isUsing: false });
      }

      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'utilisation de la carte cadeau:", error);
      toast.error("Erreur lors de l'utilisation de la carte cadeau");
      set({ isUsing: false });
      throw error;
    }
  },

  // Réinitialiser la carte courante
  resetCurrentGiftCard: () => {
    set({ currentGiftCard: null });
  },

  // Réinitialiser le store
  reset: () => {
    set({
      giftCards: [],
      currentGiftCard: null,
      isLoading: false,
      isCreating: false,
      isUsing: false,
    });
  },
}));

export default useGiftCardStore;
